import React, { PureComponent } from 'react';
import { Link } from 'react-router-dom';

import Dropdown from './Dropdown';
import Graph from './Graph';
import MobileButtons from './MobileButtons';
import Key from './Key';
import Share from './Share';
import KeyTrigger from './KeyTrigger';
import { comparison } from './comparison';

export default class extends PureComponent {
    constructor() {
        super();
        this.toggleShare = this.toggleShare.bind(this);
    }

    state = {
        isShareOpen: false,
        isKeyOpen: false,
        message: 'Compare <span class="__red">your results</span> using the dropdown below and click the categories around the map.',
        category: 'Your results are in!',
        categoryClass: '__none',
        currentCategoryID: null,
        compareToIndustry: null
    };

    componentDidMount() {
        this.animatePage();
        this.props.setWhiteLogo(true);
        const wrap = document.getElementById('PageWrap');
        wrap.classList.add('__dark');
    }


    animatePage() {
        const resultsPage = document.getElementById('ResultsPage');
        setTimeout(() => {
            resultsPage.classList.add('__active');
        }, 10);
    }

    toggleShare() {
        this.setState({
            isShareOpen: !this.state.isShareOpen
        });
    }

    toggleKey = () => {
        this.setState({
            isKeyOpen: !this.state.isKeyOpen
        });
    }

    setTextMessage = (message) => {
        this.setState({
            message
        })
    }

    setCompareToIndustry = (value) => {
        this.setState({
            compareToIndustry: value
        });
    }

    setCurrentCategoryID = (ID) => {
        this.setState({
            currentCategoryID: ID
        })
    }
    
    setMessage = (categoryID, score, categoryTitle, categoryClass) => {
        const { soc } = this.props;
        
        let { compareToIndustry } = this.state;

        this.setCurrentCategoryID(categoryID);
        
        // if users first click of icon
        if (compareToIndustry == null) {
            this.setCompareToIndustry(true);
            compareToIndustry = true; 
        }


        // find category in comparison data 
        const category = comparison.find(cat => cat.id == categoryID);
        const socData = compareToIndustry ? category.data.find(data => data.soc == soc) : category.average;
        
        
        if (score > socData.max) {
            // higher than average
            this.setState({
                category: categoryTitle,
                categoryClass,
                message: {
                    compareToIndustry: `Great news! <span class="__red">Your job</span> scored higher than <span>jobs similar to yours</span> for  ${categoryTitle}.`,
                    compareToBritain: `Great news! <span class="__red">Your job</span> scored higher on than the <span>overall UK average</span> for ${categoryTitle}.`
                }
            });
        } else if (score < socData.min) {
            // lower than average
            this.setState({
                category: categoryTitle,
                categoryClass,
                message: {
                    compareToIndustry: `Oh dear! <span class="__red">Your job</span> scored lower than <span>jobs similar to yours</span> for ${categoryTitle}.`,
                    compareToBritain: `Oh dear! <span class="__red">Your job</span> scored lower than the <span>overall UK average</span> for ${categoryTitle}.`
                }
            });
        } else {
            this.setState({
                category: categoryTitle,
                categoryClass,
                message: {
                    compareToIndustry: `Ok. <span class="__red">Your job</span> scored on average with <span>jobs similar to yours</span> for ${categoryTitle}.`,
                    compareToBritain: `Ok. <span class="__red">Your job</span> scored within the <span>overall UK average</span> for ${categoryTitle}.`
                }
            });
        }
    }

    renderMessage() {
        const { message, compareToIndustry, currentCategoryID } = this.state;

        let renderedMessage = message;

        if (compareToIndustry != null && currentCategoryID != null) {
            // If icon is clicked and compare to industry is set
            renderedMessage = compareToIndustry ? message.compareToIndustry : message.compareToBritain;
        } else if (compareToIndustry && currentCategoryID == null) {
            // if compare to industry is true by no icon is selected
            renderedMessage = 'Compare <span class="__red">your results</span> to <span>similar jobs to yours</span> by clicking the categories around the map.';
        } else if (compareToIndustry == false && currentCategoryID == null) {
            // if compare to industry is false by no icon is selected
            renderedMessage = 'Compare <span class="__red">your results</span> to the <span>UK average</span> by clicking the categories around the map.';
        }

        return (
            <h1 className={compareToIndustry ? 'resultswrap-title __ind' : 'resultswrap-title __brit'} dangerouslySetInnerHTML={{__html: renderedMessage }}/>
        );
    }

    render() {
        // fbq('trackCustom', 'QuizCompleted');
        const { isShareOpen, isKeyOpen, category, categoryClass, compareToIndustry } = this.state;
        const { categories, soc } = this.props;
        
        return (
            <React.Fragment>
                <Share isShareOpen={isShareOpen} />
                <div className={isKeyOpen ? "overlay __active" : "overlay"} />
                <div className="resultswrap" id="ResultsPage">
                    {isKeyOpen && (
                        <div className="resultswrap-key">
                            <Key categories={categories} toggleKey={this.toggleKey} />
                        </div>
                    )}
                    
                    <div className="resultswrap-button d-none d-lg-block">
                        <div className="resultswrap-keytrigger d-none d-lg-inline-block">
                            <KeyTrigger isKeyOpen={isKeyOpen} toggleKey={this.toggleKey} />
                        </div>
                        <Link to="/how-its-calculated" className="sqbutton">How are the scores calculated?</Link>
                        <div className="sqbutton" onClick={() => this.toggleShare()}>Share results</div>
                    </div>
                    <div className="row align-items-center">
                        <div className="col-lg-6 col-xl-6">
                            <div className="resultswrap-content">
                                <h2 className={`resultswrap-subtitle ${categoryClass}`}>{category}</h2>
                                
                                {this.renderMessage()}

                                <div className="resultswrap-dropdown">
                                    <Dropdown compareToIndustry={compareToIndustry} setCompareToIndustry={this.setCompareToIndustry} />
                                </div>
                            </div>
                        </div>
                        <div className="col-lg-6 col-xl-6">
                            <div className="resultswrap-graph">
                                {categories && (
                                    <Graph compareToIndustry={compareToIndustry} setCompareToIndustry={this.setCompareToIndustry} setMessage={this.setMessage} soc={soc} categories={categories} />
                                )}
                            </div>
                        </div>
                    </div>
                    <div className="resultswrap-mob">
                        <MobileButtons toggleShare={this.toggleShare} isShareOpen={isShareOpen} isKeyOpen={isKeyOpen} toggleKey={this.toggleKey} />
                    </div>
                                        
                    <div className="resultswrap-moblink">    
                        <Link to="/how-its-calculated" className="sqbutton d-lg-none">How are the scores calculated?</Link>
                    </div>
                </div>
                
            </React.Fragment>
        );
    }
}



// WEBPACK FOOTER //
// ./src/Results/index.js